import commonToggles from "@charmdeer/common/lib/runtime/toggle";
import { computed } from "vue";

import { useChannelStoreHook } from "@/store/modules/channel";
export const useToggles = (key: string) => {
  const channelStore = useChannelStoreHook();
  const channelKey = computed(() => channelStore.channel?.key);

  const toggle = computed<boolean>(() => {
    return commonToggles.isActive(key, channelKey.value);
  });
  return toggle;
};
